import type { KpiCardSpec } from './card-spec';

/**
 * The Daily active users scalar, shown on the Engagement page's Usage &
 * adoption section and the Users page's Active users section. Both pages also
 * carry a trend on the same metric, whose last point is this figure.
 */
export const DAILY_ACTIVE_USERS_SCALAR_CARD: KpiCardSpec = {
    title: 'Daily active users',
    source: 'login-activity',
    metric: 'dailyActiveUsers',
    form: 'number',
    size: 'sm',
    description:
        'Users who signed in on the last day of the selected period, counted once each, with a period-over-period delta.',
};
